export const NextcloudFreeProductCodeConst = 'managed-application-nextcloud-free';
export const NextcloudUnlimitedStorageValue = -1;
